function getInitials(name: string) {
	return name
		.split(/\s+/)
		.filter(Boolean)
		.map((part) => part[0])
		.join('')
		.slice(0, 2)
		.toUpperCase()
}

export function FacultyPhoto({
	name,
	imageUrl,
	className = '',
}: {
	name: string
	imageUrl?: string
	className?: string
}) {
	if (imageUrl) {
		return (
			<img
				className={`rounded-lg object-cover shadow-lg ${className}`}
				src={imageUrl}
				alt={name}
			/>
		)
	}

	return (
		<div
			className={`flex aspect-[3/2] items-center justify-center rounded-lg bg-stone-800 shadow-lg ring-1 ring-stone-700 ${className}`}
			aria-label={`${name} photo coming soon`}
		>
			<div className="text-center">
				<div className="text-3xl font-bold tracking-widest text-[#f9c04d] sm:text-4xl">
					{getInitials(name)}
				</div>
				<div className="mt-2 text-xs uppercase tracking-wide text-stone-400">
					Photo coming soon
				</div>
			</div>
		</div>
	)
}
